import { ReactNode } from 'react';
import { Box } from '@qga/roo-ui/components';

import Skeleton from '@shared/v2/components/Skeleton';

import Divider from '@/v2/components/ui/Divider';

export type PriceContainerProps = {
  children: ReactNode;
  includeDivider?: boolean;
  borderColor?: string;
};

const PriceContainer = ({
  children,
  includeDivider = true,
  borderColor = 'brand.primary',
}: PriceContainerProps) => {
  return (
    <>
      {includeDivider && <Divider my="4" width="100%" />}
      <Skeleton height="5rem">
        <Box pl="17px" borderLeft="3" borderColor={borderColor}>
          {children}
        </Box>
      </Skeleton>
    </>
  );
};

export default PriceContainer;
